import styled from 'styled-components/native';

export default styled.Image`
  width: 24px;
  height: 24px;
  border-radius: 11px;
  border: 0.4px solid rgba(255, 255, 255, 0.52);
  margin-right: 7px;
`;
